export const TimeTrackerSearch = {
  Patient: {
    All: 'all',
    AllText: 'All',
  },
};

export const TypesOfService = [
  { id: 1, name: 'Clinical Doc.' },
  { id: 2, name: 'Contact Attempts' },
  { id: 3, name: 'Diag. Interview' },
  { id: 4, name: 'Follow Up Visit' },
  { id: 5, name: 'Intake Packet' },
  { id: 6, name: 'Group Treatment' },
  { id: 7, name: 'Initial Assessment' },
  { id: 8, name: 'Outcome Measure' },
  { id: 9, name: 'Registry Mgmt' },
  { id: 10, name: 'Screening Interview' },
  { id: 11, name: 'Caseload Review' },
  { id: 12, name: 'Team Communication' },
  { id: 13, name: 'Warm Connection' },
];

export const TimeTrackerAssessmentType = {
  Interview: 1,
  Monitor: 2,
};
